"use client"

import Image from "next/image"
import Link from "next/link"
import LocalizedClientLink from "@modules/common/components/localized-client-link"
import { Facebook, Instagram, MapPin, Mail, Phone, Cog, ChevronRight } from "lucide-react"
import junta from "../../../../../public/images/brand/junta_andalucia.png";
import aemps from "../../../../../public/images/brand/aemps.png";
import aemps_cima from "../../../../../public/images/brand/aemps_cima.png";
import cofalmeria from "../../../../../public/images/brand/cofalmeria.png";

export default function Footer() {

  const openCookieSettings = () => {
    window.dispatchEvent(new CustomEvent("fp51:open-cookie-settings"))
  }

  return (
    <footer className="bg-[#F599A6] text-white pt-10 text-sm">
      <div className="max-w-screen-xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Logo e Información legal */}
          <div>

            <p>
              <strong>Farmacia Paseo 51</strong><br />
              Ldo. Julio Pedro Bedmar Ramírez, Nº Colegiado 1513<br />
              Colegio Oficial de Farmacéuticos de Almería. NICA 19213
            </p>
            <p>              Todos los precios incluyen IVA
</p>
            <br />

            <ul className="space-y-2">
              <li>
                <a
                  href="https://maps.google.com/?q=Paseo+de+Almer%C3%ADa+51+Almer%C3%ADa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2"
                >
                  <MapPin size={16} />Paseo de Almería, 51 04001 Almería
                </a>
              </li>
              <li>
                <a href="mailto:info@farmaciapaseo51.com" className="flex items-center gap-2">
                  <Mail size={16} />info@farmaciapaseo51.com
                </a>
              </li>
              <li>
                <a href="tel:950236984" className="flex items-center gap-2">
                  <Phone size={16} />950 23 69 84
                </a>
              </li>
              <li>
                <a href="tel:655622299" className="flex items-center gap-2">
                  <Phone size={16} />655 62 22 99
                </a>
              </li>
            </ul>
            {/* Redes sociales (auditoría a11y: enlaces solo-icono sin texto
                discernible → aria-label) */}
            <div className="flex mt-4 space-x-4">
              <a href="https://www.facebook.com/people/Farmacia-Paseo-51/100063685052592/" target="_blank" rel="noreferrer" aria-label="Facebook de Farmacia Paseo 51" className="hover:text-blue-500">
                <Facebook />
              </a>
              <a href="https://www.instagram.com/farmaciapaseo51/" target="_blank" rel="noreferrer" aria-label="Instagram de Farmacia Paseo 51" className="hover:text-pink-500">
                <Instagram />
              </a>
            </div>
            {/* T20: enlace al Google Business Profile (share link oficial del panel) */}
            <a
              href="https://share.google/g1M8UxKGOYIKI7KM1"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 inline-block text-xs text-white/90 hover:text-white underline"
            >
              ⭐ Valóranos en Google
            </a>


          </div>

          {/* Información */}
          <div>
            <h3 className="font-semibold mb-2">Información</h3>
            <ul className="space-y-2">
              <li><LocalizedClientLink href="/farmacia-en-almeria" className="flex items-center gap-2"><ChevronRight size={16} />Farmacia en Almería</LocalizedClientLink></li>
              <li><LocalizedClientLink href="/farmacia-de-guardia" className="flex items-center gap-2"><ChevronRight size={16} />Farmacia de guardia</LocalizedClientLink></li>
              <li><LocalizedClientLink href="/informacion/sobre-nosotros" className="flex items-center gap-2"><ChevronRight size={16} />Sobre nosotros</LocalizedClientLink></li>
              <li><LocalizedClientLink href="/contacto" className="flex items-center gap-2"><ChevronRight size={16} />Contacto</LocalizedClientLink></li>
              <li><LocalizedClientLink href="/informacion/aviso-legal" className="flex items-center gap-2"><ChevronRight size={16} />Aviso legal</LocalizedClientLink></li>
              {/* <li><LocalizedClientLink href="/informacion/condiciones-compra-venta-3" className="flex items-center gap-2"><ChevronRight size={16} />Condiciones compra-venta</LocalizedClientLink></li> */}
              <li><LocalizedClientLink href="/informacion/politica-de-privacidad" className="flex items-center gap-2"><ChevronRight size={16} />Política de Privacidad</LocalizedClientLink></li>
              <li><LocalizedClientLink href="/informacion/politica-de-cookies" className="flex items-center gap-2"><ChevronRight size={16} />Política de Cookies</LocalizedClientLink></li>
              {/* Políticas exigidas por la normativa de comercio electrónico y
                  por los agentes de compra: enlaces explícitos, no agrupados
                  bajo una etiqueta genérica. */}
              <li><LocalizedClientLink href="/envios-devoluciones" className="flex items-center gap-2"><ChevronRight size={16} />Envíos: plazos y costes de entrega</LocalizedClientLink></li>
              <li><LocalizedClientLink href="/envios-devoluciones" className="flex items-center gap-2"><ChevronRight size={16} />Devoluciones y reembolsos</LocalizedClientLink></li>
              <li><LocalizedClientLink href="/informacion/aviso-legal" className="flex items-center gap-2"><ChevronRight size={16} />Términos y condiciones de servicio</LocalizedClientLink></li>
            </ul>
          </div>

          {/* Mi cuenta */}
          <div>
            <h3 className="font-semibold mb-2">Mi cuenta</h3>
            <ul className="space-y-2">
              <li><LocalizedClientLink href="/account/orders" className="flex items-center gap-2"><ChevronRight size={16} />Mis pedidos</LocalizedClientLink></li>
              <li><LocalizedClientLink href="/account/addresses" className="flex items-center gap-2"><ChevronRight size={16} />Mis direcciones</LocalizedClientLink></li>
              <li><LocalizedClientLink href="/account/profile" className="flex items-center gap-2"><ChevronRight size={16} />Mis datos</LocalizedClientLink></li>
              <li>
                <div
                  role="button"
                  tabIndex={0}
                  onClick={openCookieSettings}
                  onKeyDown={(e) => e.key === "Enter" && openCookieSettings()}
                  className="flex items-center gap-2 cursor-pointer"
                >
                  <Cog size={16} />
                  Configuración de cookies
                </div>
              </li>            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="font-semibold mb-2 border-b border-white">Horario del 1 de octubre al 31 de mayo</h3>

            <ul className="space-y-2 ">
              <li>L-V 9h a 14h y 16:30h a 20:30h</li>
              <li>Sábados de 09:30h a 14h</li>
              <li></li>

            </ul>
            <h3 className="font-semibold mb-2 border-b border-white">Horario del 1 de junio al 30 septiembre</h3>

            <ul className="space-y-2 ">

              <li>L-V 9h a 14h y 17h a 21h</li>
              <li>Sábados de 9:30h a 14h (excepto julio y agosto 9:30h a 13:30h)</li>
            </ul>


          </div>
        </div>

        {/* Logos institucionales */}
        <div className="flex flex-wrap justify-center items-center gap-4 mt-10">
           <a href="https://distafarma.aemps.es/farmacom/faces/inicio.xhtml" target="_blank" rel="noreferrer">
            <Image src={aemps} alt="Distafarma" width={150} height={50} />
          </a>
          <a
            href="https://distafarma.aemps.es/farmacom/faces/sec/CCAA/listadoCCAA.xhtml?farma=fbc927d70811dd20e7782bb185e3a22c"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Image
              src="https://distafarma.aemps.es/farmacom/ServletIcono?farma=fbc927d70811dd20e7782bb185e3a22c"
              alt="Logotipo Europeo de Farmacia Online"
              width={150}
              height={80}
              className="object-contain hover:scale-105 transition-transform"
            />
          </a>
            <a href="https://www.cofalmeria.com" target="_blank" rel="noreferrer">
            <Image src={cofalmeria} alt="Colegio Oficial de Farmacéuticos de Almería" width={150} height={50} />
          </a>
         
          <a href="http://www.aemps.gob.es/cima/fichasTecnicas.do?metodo=detalleForm&receta=N&comercializado=S" target="_blank" rel="noreferrer">
            <Image src={aemps_cima} alt="AEMPS CIMA" width={150} height={50} />
          </a>
        
          <a href="https://juntadeandalucia.es/organismos/saludyconsumo/areas/sistema-sanitario/farmacia/paginas/venta-sin-receta.html" target="_blank" rel="noreferrer">
            <Image src={junta} alt="Consejería Salud" width={130} height={100} />
          </a>
        </div>

        {/* Footer inferior */}
        <div className="border-t border-white/20 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center text-center md:text-left">
        </div>
      </div>
    </footer>
  )
}
